import {createFileRoute, Outlet, useLocation} from '@tanstack/react-router';
import {COMPANY_DETAIL} from '@/practitioner/routing/paths';
import {companyAdminGranted, grantUser} from '@/practitioner/routing/utils/beforeLoadUtils';

import CompanyDetail from '@/practitioner/views/company/CompanyDetail';

function CompanyLayout() {
  const {pathname} = useLocation();
  const isRoot = pathname === COMPANY_DETAIL;
  return isRoot ? <CompanyDetail /> : <Outlet />;
}

export const Route = createFileRoute('/(practitioner)/company')({
  component: CompanyLayout,
  beforeLoad: grantUser(companyAdminGranted)
});
